'use strict';
import { compose, createStore, applyMiddleware } from 'redux';
import keyMirror from 'keymirror';
import { combineReducers } from 'redux-immutablejs';
import Immutable from 'immutable';
import thunkMiddleware from 'redux-thunk';
import {reducer as reduxFormReducer} from 'redux-form';
import reqwest from 'reqwest';

/*
    ActionTypes
 */
const ActionTypes = keyMirror({
    loadCart: null,
    loadCartSuccess: null,
    loadCartError: null,
    removeItem: null,
    removeItemSuccess: null,
    removeItemError: null,
    addProductSuccess: null,
    addProductError: null,
    changeItem: null,
    changeItemSuccess: null,
    changeItemError: null,
    selectPayment: null,
    handleSubmit: null,
    showCheckout: null,
    doCheckout: null,
    doCheckoutSuccess: null,
    doCheckoutError: null,
    editComment: true

});

const checkoutFields = {
    email: { placeholder: 'E-Mail'},
    phone: { placeholder: 'Telefonnummer'},
    billing_is_shipping: { label: 'Wie Rechnungsadresse'},
    billing_company: { placeholder: 'Firma (optional)'},
    billing_first_name: { placeholder: 'Vorname'},
    billing_last_name: { placeholder: 'Nachname'},
    billing_street: { placeholder: 'Straße und Hausnummer'},
    billing_city_name: { placeholder: 'Stadt'},
    billing_city_plz: { placeholder: 'Postleitzahl'},
    billing_country: { placeholder: 'Land'},
    shipping_company: { placeholder: 'Firma'},
    shipping_first_name: { placeholder: 'Vorname'},
    shipping_last_name: { placeholder: 'Nachname'},
    shipping_street: { placeholder: 'Straße und Hausnummer'},
    shipping_city_name: { placeholder: 'Stadt'},
    shipping_city_plz: { placeholder: 'Postleitzahl'},
    shipping_country: { placeholder: 'Land'}
};

/*
    Actions
 */
const Actions = {
    loadCart: () => {
        return { type: ActionTypes.loadCart };
    },
    loadCartSuccess: (payload) => {
        return { type: ActionTypes.loadCartSuccess, payload };
    },
    selectPayment: (payload) => {
        return { type: ActionTypes.selectPayment, payload };
    },
    handleSubmit: (payload) => {
        return { type: ActionTypes.handleSubmit, payload };
    },
    showCheckout: (payload) => {
        return { type: ActionTypes.showCheckout, payload };
    },
    editComment: (payload) => {
        return { type: ActionTypes.editComment, payload };
    },
    removeItem: (payload) => {
        return (dispatch) => {
            dispatch({type: ActionTypes.removeItem});
            return reqwest({
                method: 'post',
                url: '/api/cart/remove',
                data: payload
            }).then(json => dispatch({
                type: ActionTypes.removeItemSuccess,
                payload: json
            })).catch(err => dispatch({
                type: ActionTypes.removeItemError,
                payload: err
            }));
        };
    },
    changeItem: (payload) => {
        return (dispatch) => {
            dispatch({type: ActionTypes.removeItem});
            return reqwest({
                method: 'post',
                url: '/api/cart/change',
                data: payload
            }).then(json => dispatch({
                type: ActionTypes.changeItemSuccess,
                payload: json
            })).catch(err => dispatch({
                type: ActionTypes.changeItemError,
                payload: err
            }));
        };
    },
    doCheckout: () => {
        return (dispatch, getState) => {
            dispatch({type: ActionTypes.doCheckout});
            let state = getState();
            let payload = state.getIn(['cart', 'checkout']).toJS();
            payload.payment = state.getIn(['cart', 'selected_payment']);

            return reqwest({
                method: 'post',
                url: '/api/cart/order',
                data: payload
            }).then(json => dispatch({
                type: ActionTypes.doCheckoutSuccess,
                payload: json
            })).catch(err => dispatch({
                type: ActionTypes.doCheckoutError,
                payload: err
            }));
        };
    }
};

/*
    Form Reducer
 */
const FormReducer = (state = Immutable.fromJS({}), action) => {

    // Detect plz / city suggests
    if (action.type === 'redux-form/CHANGE') {
        if ((action.field === 'billing_city_name' || action.field === 'shipping_city_name') && typeof action.value === 'object') {
            action.value = action.value.city;
        }
        if ((action.field === 'billing_city_plz' || action.field === 'shipping_city_plz') && typeof action.value === 'object') {
            action.value = action.value.postcode;
        }
    }

    return Immutable.fromJS(reduxFormReducer(state.toJS(), action));
};


/*
    Set state from cart ajax
 */
const setStateFromRemote = (state, payload) => {
    return state.set('loading', false)
        .set('products', Immutable.fromJS(payload.products))
        .set('payment', Immutable.fromJS(payload.payment))
        .set('totals', Immutable.fromJS(payload.totals));
};

/*
    Reducer
 */
const CartReducer = (state = Immutable.fromJS({}), action) => {
    switch (action.type) {

    case ActionTypes.loadCart:
        state = state.set('loading', true);
        break;

    case ActionTypes.loadCartSuccess:
        state = setStateFromRemote(state, action.payload);
        break;

    case ActionTypes.removeItemSuccess:
        state = setStateFromRemote(state, action.payload);
        break;

    case ActionTypes.changeItemSuccess:
        state = setStateFromRemote(state, action.payload);
        break;

    case ActionTypes.selectPayment:
        state = state.set('selected_payment', action.payload);
        break;

    case ActionTypes.handleSubmit:
        window.scrollTo(0, 0);
        state = state.set('checkout', Immutable.fromJS(action.payload)).set('preview', true);
        break;

    case ActionTypes.showCheckout:
        state = state.set('checkout', null).set('preview', false);
        break;

    case ActionTypes.doCheckout:
        state = state.set('loading', true);
        break;


    case ActionTypes.editComment:
        state = state.setIn(['checkout', 'comment'], action.payload);
        break;

    case ActionTypes.doCheckoutSuccess:
        window.scrollTo(0, 0);
        state = state.set('success', true).set('products', Immutable.fromJS([]));
        break;

    default:
        state = state;
        break;

    }

    return state;
};


/**
 * creates the store by combining
 * the reducer with the initial state
 * @param  {[type]} initialState [description]
 * @return {[type]}              [description]
 */
const configureStore = function configureStore() {
    const Reducer = combineReducers({
        form: FormReducer,
        cart: CartReducer
    });

    var finalCreateStore = compose(applyMiddleware(thunkMiddleware))(createStore);
    let state = Immutable.fromJS({
        // "checkout": {
        //     "shipping_country": "Deutschland",
        //     "billing_street": "Petersburger Str. 49",
        //     "phone": "01762438467",
        //     "billing_city_plz": "10249",
        //     "billing_last_name": "Müller",
        //     "billing_country": "Deutschland",
        //     "billing_company": "Müller & Sohn",
        //     "billing_city_name": "Berlin",
        //     "email": "steffen@mllrsohn.com",
        //     "billing_first_name": "Steffen",
        //     "billing_is_shipping": true
        // },
        cart: {
            selected_payment: 'pickup',
            success: false,
            loading: false,
            products: [],
            totals: {},
            payment: {},
            paymentInfo: [{
                name: 'pickup',
                description: 'Selbstabholer / Barzahlung',
                info: 'nach vorheriger Vereinbarung'
            }, {
                name: 'cash_in_advance',
                description: 'Versand / Vorkasse'
            }]
        }
    });
    let store = finalCreateStore(Reducer, state);

    // Put the ajax handler on the cart instance
    // to access them from the passed in store
    store.loadCart = () => {
        store.dispatch(Actions.loadCart());
        return reqwest({method: 'get', url: '/api/cart'}).then(result => {
            store.dispatch(Actions.loadCartSuccess(result));
            return result;
        }).catch(err => {
            store.dispatch(Actions.loadCartError(err));
        });
    };

    store.addProduct = (productId, qty = 1) => {
        return reqwest({
            method: 'post',
            url: '/api/cart/add',
            data: { product_id: productId, quantity: qty }
        }).then(result => {
            store.dispatch(Actions.addProductSuccess(result));
        }).catch(err => {
            store.dispatch(Actions.addProductError(err));
        });
    };

    return store;
};


module.exports = {
    configureStore: configureStore,
    Actions: Actions,
    checkoutFields: checkoutFields
};



// WEBPACK FOOTER //
// ./static/app/checkout/state.js